export default {
  props: {
    title: {
      type: String,
      required: true,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {}
};